const mediaItems = [
  {
    title: '《流浪地球3》抢先看：人类文明的最后抉择',
    desc: '郭帆导演科幻巨制续作，人类面临前所未有的危机，地球的命运将何去何从？',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20scene%20with%20giant%20planet%20and%20spacecraft%2C%20dramatic%20nebula%20lighting%2C%20cinematic%20science%20fiction%20movie%20atmosphere%2C%20Earth%20from%20space%20with%20massive%20engines%2C%20dark%20cosmic%20background%20with%20stars&width=800&height=450&seq=media-01-2026&orientation=landscape',
    duration: '02:35',
    views: '128万',
  },
  {
    title: '暑期档必看：十大国产佳片深度解析',
    desc: '从悬疑到喜剧，从动画到文艺，盘点今年夏天最值得走进电影院的国产电影。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinema%20entrance%20with%20colorful%20movie%20posters%20displayed%2C%20warm%20golden%20hour%20lighting%2C%20people%20walking%20into%20theater%2C%20Chinese%20film%20festival%20atmosphere%2C%20red%20carpet%20and%20spotlights%2C%20luxurious%20movie%20theater&width=800&height=450&seq=media-02-2026&orientation=landscape',
    duration: '05:18',
    views: '96万',
  },
  {
    title: '韩剧《眼泪女王》名场面回顾',
    desc: '金秀贤、金智媛主演，年度催泪大戏经典片段合集，那些让你泪崩的高能瞬间。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20emotional%20moment%20with%20rain%20scene%2C%20dramatic%20lighting%2C%20couple%20under%20umbrella%20in%20Seoul%20street%2C%20warm%20and%20melancholic%20atmosphere%2C%20cinematic%20color%20grading%2C%20autumn%20leaves&width=800&height=450&seq=media-03-2026&orientation=landscape',
    duration: '08:42',
    views: '215万',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            精彩视频
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            热门影视预告、精彩片段，一睹为快
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-7xl mx-auto">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-primary-300 cursor-pointer transition-all"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-foreground-950/20 group-hover:bg-foreground-950/30 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/90 group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-primary-500 group-hover:text-background-50 text-2xl ml-0.5 transition-colors"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-0.5 bg-background-950/70 text-background-50 text-xs rounded whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading font-semibold text-foreground-950 text-sm mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed mb-3 line-clamp-2">
                  {item.desc}
                </p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}